import React from 'react';
import ReactDOM from 'react-dom';
import EventInfoContainer from '.';

const eventInfoContainer = document.getElementById('eventinfo');

// Not shown in Embedded Checkout:
if (eventInfoContainer !== null) {
  ReactDOM.render(<EventInfoContainer />, eventInfoContainer);
}



// WEBPACK FOOTER //
// ./frontend/react/apps/eventInfoHeader/entry.js